import { createQueryKeys } from '@lukemorales/query-key-factory';

import { ApprovalRequestState } from '../../../../types/ApprovalRequestState';
import { getApprovalRequestsByEmailAndState } from '../../../offer/ApprovalRequest/offer-approval-request.api';

export const approvalRequests = createQueryKeys('approvalRequests', {
    byEmailAndState: (userEmailAddress: string, state: ApprovalRequestState) => ({
        queryKey: [userEmailAddress, state],
        queryFn: () => getApprovalRequestsByEmailAndState(userEmailAddress, state),
    }),
});
